import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DownloadModalService } from '../../services/download-modal.service';
import { environment } from '../../../environments/environment';

const BASE_URL = environment.apiUrl;
const API_BASE_URL = `${BASE_URL}/api`;
@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit {
  products: any[] = [];
  constructor(private router: Router, private downloadModal: DownloadModalService) { }
  ngOnInit() {
    this.fetchTemplates();
  }
  async fetchTemplates() {
    try {
      const response = await fetch(`${API_BASE_URL}/packages/home_masters`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      });

      const result = await response.json();
      console.log('Templates API Response:', result);
      if (result.statusCode === 200) {
        if (result.data && result.data.templates) {
          this.products = result.data.templates.map((t: any) => ({ id: t.id, title: t.name, image: `${BASE_URL}/uploads/template_images/${t.template_image}` }));
        }
      } else {
        console.error('API Error:', result);
      }
    } catch (error) {
      console.error('Request failed:', error);
    }
  }

  goToPreview(id: number): void {
    this.router.navigate(['/template-preview', id]);
  }

  goToAll(): void {
    this.router.navigate(['/viewalltemplate/all_templates']);
  }

  openDownload(product?: any): void {
    this.downloadModal.open(product ? { template_id: product.id } : null);
  }

}

